import { render } from "./Empleados.vue?vue&type=template&id=6ee45c49"
import script from "./Empleados.vue?vue&type=script&lang=js"
export * from "./Empleados.vue?vue&type=script&lang=js"

import "./Empleados.vue?vue&type=style&index=0&id=6ee45c49&lang=css"
import "./Empleados.vue?vue&type=style&index=1&id=6ee45c49&lang=css"

import exportComponent from "C:\\SistemasProyectos\\AppWeb\\historiaClinica\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__